<kve-input-dialog-wrapper>
    <nb-card-header>
        <div class="title">Section Builder - {{title}}</div>
        <div class="action">
            <nb-actions size="tiny">
                <nb-action title="Save" (click)="onSave($event)" [disabled]="!canSave">
                    <nb-icon class="toggle-icon" icon="save-outline" pack="eva">Save</nb-icon>
                </nb-action>
                <nb-action>
                    <nb-icon icon="close-circle-outline" pack="eva" (click)="ref.close()"></nb-icon>
                </nb-action>
            </nb-actions>
        </div>
    </nb-card-header>
    <div class="layout-container">
        <nb-sidebar left>
            <kve-editor-template-options [section]="section" [rendererType]="rendererType" orientation="vertical" [status]="status"></kve-editor-template-options>
        </nb-sidebar>
      <nb-sidebar right>
        <!-- <ng-container *ngIf="section.status !== 'In Progress'"> -->
            <nb-menu [items]="menuItems" tag="inputMenu"></nb-menu>
        <!-- </ng-container> -->
        
      </nb-sidebar>
      <div class="content input">
        <div class="columns">
            <div class="preview-editor-container">
                <ng-container *ngIf="hasLoaded;else loading">
                    <kve-shared-section-builder [section]="section" (updateSection)="updateSection($event)">

                    </kve-shared-section-builder>
                </ng-container>
                <ng-template #loading>
                    <div class="loading-container">
                        <div>Loading</div>
                    </div>
                </ng-template>
            </div>    
        </div>

      </div>        
    </div>
    <nb-card-footer>
        <nb-actions size="tiny" class="left">
            <nb-action>Status:</nb-action>
            <nb-action>{{section?.status}}</nb-action>
        </nb-actions>
        <nb-actions size="tiny" class="right">
            <nb-action>Add Product</nb-action>
            <nb-action>
                <nb-icon icon="plus-outline" pack="eva" (click)="addProductCell()"></nb-icon>
            </nb-action>
        </nb-actions>
        
    </nb-card-footer>
</kve-input-dialog-wrapper>
    

